// src/components/ConfirmAlert.tsx

import React from 'react';
import './ConfirmAlert.css'; // Agregaremos estilos básicos a continuación

interface ConfirmAlertProps {
  isOpen: boolean;
  title: string;
  message?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmAlert: React.FC<ConfirmAlertProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  // Maneja la confirmación y luego cierra el modal
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        {message && <p>{message}</p>}
        <div className="modal-actions">
          <button onClick={onClose} className="button-secondary">
            Cancelar
          </button>
          <button onClick={handleConfirm} className="button-danger">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAlert;